import { render, staticRenderFns } from "./BrandTable.vue?vue&type=template&id=b58fcb4a&scoped=true"
import script from "./BrandTable.vue?vue&type=script&lang=js"
export * from "./BrandTable.vue?vue&type=script&lang=js"
import style0 from "./BrandTable.vue?vue&type=style&index=0&id=b58fcb4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58fcb4a",
  null
  
)

export default component.exports